import { createApp } from 'vue';
import DynamicForm from './dynamic-form.vue';
import useI18n from '@utils/I18n';
import Notifications from '@kyvg/vue3-notification';

const startDynamicForms = async () => {
    const elements = document.querySelectorAll<HTMLElement>('[data-dynamic-form]');
    for (const el of Array.from(elements)) {
        const props = JSON.parse(el.dataset.props ?? '{}');
        const app = createApp(DynamicForm, { ...props });
        app.use(await useI18n());
        app.use(Notifications);
        app.mount(el);
    }
};

export const init = () => {
    startDynamicForms();
};
